import { put, takeEvery } from 'redux-saga/effects';

import { Types } from 'actions/mandates';
import { fetchSaga } from 'api/fetchSaga';

import { config } from 'config';

import { removeSoftHyphens } from 'utils/soft-hyphens';

import { Creators } from './../api/actions';

const { apiResponse } = Creators;

const { apis } = config;
const { GET_PAYMENT_PARTNER, GET_PAYMENT_PARTNER_SELECTION } = Types;

export function* getPaymentPartner({ id }) {
  const params = {
    path: `${apis.paymentPartners}/${id}`
  };

  return yield fetchSaga({
    params,
    actionType: GET_PAYMENT_PARTNER,
    fields: 'paymentPartner'
  });
}

export function* getPaymentPartnerSelection({ payload }) {
  const { query, isDirectDebit } = payload;
  const params = {
    path: apis.paymentPartners,
    params: {
      search_term: query,
      is_direct: isDirectDebit,
      address: true
    }
  };

  // TODO: fix for soft hyphens in the response (removed when it will be resolved on API side) - start
  const response = removeSoftHyphens(
    yield fetchSaga({
      params,
      actionType: GET_PAYMENT_PARTNER_SELECTION,
      fields: 'paymentPartners'
    })
  );

  yield put(apiResponse(GET_PAYMENT_PARTNER_SELECTION, response));
  // fix for soft hyphens in the response - end

  return response;
}

export function* paymentPartnerSaga() {
  yield takeEvery(GET_PAYMENT_PARTNER, getPaymentPartner);
  yield takeEvery(GET_PAYMENT_PARTNER_SELECTION, getPaymentPartnerSelection);
}
